export enum UserRewardStatus {
  NoAccess,
  NotEnrolled,
  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  Enrolled = 3
}
